<template>
    <modal id="duty-station-modal"
           size="default"
           v-model="showModal"
           :title="$t(this.selectedUrl ? 'edit_duty_station' : 'add_duty_station')"
           @submit="submit"
           :loading="loading"
           :preloader="preloader">

        <form :data-url='selectedUrl ? selectedUrl : DUTY_STATION'
              method="POST"
              ref="form"
              @submit.prevent="submit"
              style="height: 200px"
        >

            <app-form-group-selectable
                type="select"
                :label="$t('district')"
                list-value-field="name"
                v-model="formData.district_id"
                :chooseLabel="$t('district')"
                :error-message="$errorMessage(errors, 'district_id')"
                :fetch-url="SELECTABLE_DISTRICT"
            />


            <app-form-group
                :label="$t('name')"
                type="text"
                v-model="formData.name"
                :placeholder="$placeholder('name', '')"
                :required="true"
                :error-message="$errorMessage(errors, 'name')"
            />
        </form>
    </modal>
</template>

<script>

import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import {SELECTABLE_DISTRICT} from "../../../Config/ApiUrl";
import {DUTY_STATION} from "../../../../common/Config/apiUrl";
export default {
    name: "DutyStationCreateEditModal",
    mixins: [FormHelperMixins, ModalMixin],

    data() {
        return {
            DUTY_STATION,
            SELECTABLE_DISTRICT,
            districtList : []
        }
    },
    computed: {},
    methods: {
        submit() {
            let formData = {...this.formData};
            this.loading = true;
            this.message = '';
            this.errors = {};
            this.save(formData);
        },
        afterSuccess({data}) {
            this.formData = {};
            $('#duty-station-modal').modal('hide');
            this.$emit('input', false);
            this.toastAndReload(data.message, 'duty-station-table');
        }
    }
}
</script>